<template>
  <div class="solicitarSenha">
    <div class="container">
      <v-snackbar v-model="loginSuccess" color="success" top :timeout="8000" multi-line>
        <p>
          Alteração efetuada com sucesso! Instruções foram enviadas com sucesso
          para {{ emailCadastrado }}.
        </p>
        <v-btn color="info" @click="loginSuccess = false">Ok</v-btn>
      </v-snackbar>

      <v-snackbar color="error" v-model="loginFail" top :timeout="8000">
        <span>
<!--          Nenhum cadastro encontrado para este {{ getLabelCpfCnpj }}! Verifique os campos-->
          <!--          informados e tente novamente.-->
          {{ mensagemErro }}
        </span>
        <v-btn color="info" @click="loginFail = false">Fechar</v-btn>
      </v-snackbar>

      <h1 class="display-1 my-3">Recuperar Senha</h1>
      <v-divider></v-divider>
      <v-row wrap justify="center">
        <v-flex xs12 sm6 lg4>
          <v-card hover class="ma-4">
            <v-card-title>Redefinir senha</v-card-title>
            <v-card-text>
              <span class="body-2">
                Informe seu {{ getLabelCpfCnpj }} abaixo e enviaremos um e-mail contendo um
                link para definir uma nova senha.
              </span>

              <v-form ref="form" class="my-3">
                <!--                    v-mask="['###.###.###-##', '##.###.###/####-##']"-->
                <v-text-field
                    v-if="cpf && !cnpj"
                    v-mask="['###.###.###-##']"
                    @blur="ajustaCpf"
                    v-model="cpfCnpj"
                    :rules="regrasObrigacao"
                    :label="getLabelCpfCnpj"
                    required
                    clearable
                    prepend-icon="account_circle">
                </v-text-field>

                <v-text-field
                    v-if="cnpj && !cpf"
                    v-mask="['XX.XXX.XXX/XXXX-##']"
                    @input="cpfCnpj = cpfCnpj.toUpperCase()"
                    v-model="cpfCnpj"
                    :rules="regrasObrigacao"
                    :label="getLabelCpfCnpj"
                    required
                    clearable
                    prepend-icon="account_circle">
                  <!--                    @blur="ajustaCnpj"-->
                </v-text-field>

                <v-text-field
                    v-if="cpf && cnpj"
                    v-mask="['XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                    v-model="cpfCnpj"
                    @input="cpfCnpj = cpfCnpj.toUpperCase()"
                    :rules="regrasObrigacao"
                    :label="getLabelCpfCnpj"
                    required
                    clearable
                    prepend-icon="account_circle">
<!--                  @blur="ajustaCpfCnpj"-->
                </v-text-field>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn v-if="permiteRedefinicaoEmail" color="primary" dark outlined small type="submit" router
                     to="RecuperarEmail">
                <v-icon small left>history</v-icon>
                <span>Recuperar e-mail</span>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn small color="primary" dark type="submit" @click="recuperarSenha">
                <v-icon left>send</v-icon>
                <span>Enviar senha</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-row>
    </div>
  </div>
</template>

<script>
import {mask} from "vue-the-mask";
import cpfCnpjMixin from "@/mixins/CpfCnpjMixin";

export default {
  directives: {mask},
  mixins: [cpfCnpjMixin],
  props: {
    // cpf: {
    //   type: Boolean,
    // },
    // cnpj: {
    //   type: Boolean,
    // },
  },
  data() {
    return {
      cpf: false,
      cnpj: false,
      permiteRedefinicaoEmail: false,
      loginSuccess: false,
      loginFail: false,
      emailCadastrado: "",
      regrasObrigacao: [(v) => !!v || "Campo obrigatório!"],
      mensagemErro: ""
    };
  },
  methods: {
    recuperarSenha() {
      this.removeMask();
      if (!this.$refs.form.validate()) {
        // console.log("Erro!");
      } else {
        this.cpfCnpj = this.removeMask();

        this.$httpNF
            .put(`/acesso/esqueceusenha/sistema/NOTAFISCAL_EXTERNO/login/${this.cpfCnpj}`)
            .then((res) => {
              this.emailCadastrado = res.data;
              this.loginSuccess = true;
            })
            .catch((error) => {
              console.log(error);
              this.loginFail = true;

              if (error.response !== undefined && error.response.data !== undefined)
                this.mensagemErro = error.response.data
              else
                this.mensagemErro = 'Nenhum cadastro encontrado para este ' + this.getLabelCpfCnpj +
                    '! Verifique os campos informados e tente novamente.'
            });
      }
    },
    removeMask() {
      return this.cpfCnpj.replace(/[^a-zA-Z0-9]/g, "");
    },
  },
  computed: {
    getLabelCpfCnpj() {
      if (this.cpf && this.cnpj)
        return "CPF/CNPJ";
      else if (this.cpf)
        return "CPF";
      else if (this.cnpj)
        return "CNPJ";
      else
        return "";
    },
  },
  mounted() {
    this.cpf = this.$route.params.cpf;
    this.cnpj = this.$route.params.cnpj;
    this.permiteRedefinicaoEmail = this.$route.params.permiteRedefinicaoEmail;
  }
};
</script>

<style scoped></style>
